



















































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { NotifyHelper } from 'vue-kit'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import deliveryPointsStore from '@/stores/DeliveryPointsStore'

@Component
export default class PopupMenu extends Vue {
  @Prop(Object)
  point: DeliveryPoint

  deliveryPointsStore = deliveryPointsStore

  isShowConfirmDialog: boolean = false
  isShowMenu: boolean = false

  removeDeliveryPoint() {
    this.deliveryPointsStore
      .deleteDeliveryPoint(this.point.id as number)
      .catch(() => {
        NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
      })
      .finally(() => {
        this.isShowConfirmDialog = false
      })
  }

  toggleEnabled() {
    const model = Object.assign({}, this.point, {
      enabled: !this.point.enabled,
    })
    this.deliveryPointsStore
      .saveDeliveryPoint(model)
      .then(() => NotifyHelper.success('Пункт выдачи сохранен'))
      .catch(() => NotifyHelper.success('Ошибка сервера'))
  }

  get enabledBtnLabel() {
    return this.point.enabled ? 'Отключить' : 'Включить'
  }

  @Watch('isShowConfirmDialog')
  closePopup() {
    this.isShowMenu = false
  }
}
